import integrationFile from "../../assets/markDownFiles/integration_process.md?raw";

console.log("MD content:", integrationFile);

export const SEARCH_FILES = [
    {id: "intergration_1", title: "intergration", content: integrationFile, path: "/introduction/onboarding"},
];
